import data from "../../../../../src/Flash/Flash.docs.json";
import * as React from 'react';
export default {
  data,
  React
};